<p-accordion >
  <p-accordionTab [header]="title" [headerStyleClass]="headerClass">
    <ng-content></ng-content>
  </p-accordionTab>
</p-accordion>